export default "__VITE_ASSET__9pxOYYLD__"